import { render, staticRenderFns } from "./ProductPlanDetails.vue?vue&type=template&id=68a21246&scoped=true&"
import script from "./ProductPlanDetails.vue?vue&type=script&lang=js&"
export * from "./ProductPlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlanDetails.vue?vue&type=style&index=0&id=68a21246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a21246",
  null
  
)

export default component.exports